"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _commonUIColors = require("../../utils/commonUIColors"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Modal'
});
schema.propTypes = {
  actions: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    onClick: _reactDesc.PropTypes.func.isRequired,
    text: _reactDesc.PropTypes.string.isRequired
  })).description('An array of objects containing a subset of props valid for the Button. Specifically excluded are `size` and `variant`.'),
  closeHint: _reactDesc.PropTypes.string.description('The text to present in the tooltip when hovering over the close button.'),
  color: _reactDesc.PropTypes.oneOf(_commonUIColors.commonUIColorKeys).description('The icon color; Will override the default color associated with any specified `intent`.').format('string'),
  icon: _reactDesc.PropTypes.element.description('Which `iconix` icon to display; Will override the default icon associated with any specified `intent`.'),
  id: _reactDesc.PropTypes.string.description('A unique identifier for the modal.'),
  intent: _reactDesc.PropTypes.oneOf(['information', 'success', 'warning', 'danger', 'help']).description('Shortcuts to the most common combinations of icon and color.'),
  onClose: _reactDesc.PropTypes.func.description('The event handler called to close the modal. If not provided, the modal will not include a close button and closing by clicking outside or pressing the "Esc" key will be disabled.'),
  title: _reactDesc.PropTypes.string.description('The text for rendering in the H2 at the top of the modal').isRequired,
  visible: _reactDesc.PropTypes.bool.description('A boolean value used to control whether the modal is visible or not').defaultValue('false'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index value for the modal & overlay.')
};
var _default = schema;
exports.default = _default;